import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_420_83998)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.59998 7.99996C2.59998 6.85996 3.52665 5.93329 4.66665 5.93329H7.33331V4.66663H4.66665C2.82665 4.66663 1.33331 6.15996 1.33331 7.99996C1.33331 9.83996 2.82665 11.3333 4.66665 11.3333H7.33331V10.0666H4.66665C3.52665 10.0666 2.59998 9.13996 2.59998 7.99996ZM5.33331 8.66663H10.6666V7.33329H5.33331V8.66663ZM11.3333 4.66663H8.66665V5.93329H11.3333C12.4733 5.93329 13.4 6.85996 13.4 7.99996C13.4 9.13996 12.4733 10.0666 11.3333 10.0666H8.66665V11.3333H11.3333C13.1733 11.3333 14.6666 9.83996 14.6666 7.99996C14.6666 6.15996 13.1733 4.66663 11.3333 4.66663Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_420_83998",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
